module.exports = __webpack_public_path__ + "img/midia_2.fa05730c.png";